import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/mnd-publish-frontend/mnd-publish-frontend/apps/public/app/[locale]/error.tsx");
